import React from 'react';
import { MapPin, Calendar, User, Mail } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const PetCard = ({ pet, onClick }) => {
  const statusColors = {
    perdido: 'bg-[#E57373]',
    encontrado: 'bg-[#81C784]',
    adocao: 'bg-[#64B5F6]'
  };

  const statusLabels = {
    perdido: 'Perdido',
    encontrado: 'Encontrado',
    adocao: 'Para Adoção'
  };

  const porteLabels = {
    pequeno: 'Pequeno',
    medio: 'Médio',
    grande: 'Grande'
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <div 
      className="pet-card bg-[#FCEBC5] shadow-lg border-2 border-[#C4956A] cursor-pointer group"
      onClick={() => onClick && onClick(pet)}
      data-testid={`pet-card-${pet.id}`}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden rounded-t-[22px]">
        {pet.imagem_url ? (
          <img 
            src={pet.imagem_url} 
            alt={pet.nome}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full bg-[#F5E6C8] flex items-center justify-center">
            <span className="text-6xl">🐾</span>
          </div>
        )}
        
        {/* Status Badge */}
        <div className="absolute top-3 left-3">
          <Badge className={`${statusColors[pet.status]} text-white font-semibold px-3 py-1 rounded-full`}>
            {statusLabels[pet.status]}
          </Badge>
        </div>

        {/* Porte Badge */}
        <div className="absolute top-3 right-3">
          <Badge className="bg-[#6B5344] text-white font-medium rounded-full">
            {porteLabels[pet.porte]}
          </Badge>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-3">
        {/* Name and Species */}
        <div>
          <h3 className="text-lg font-bold text-[#5D4A3A] truncate">{pet.nome}</h3>
          <p className="text-sm text-[#7A5B3E] font-medium">
            {pet.especie} {pet.raca && `• ${pet.raca}`}
          </p>
        </div>

        {/* Description */}
        <p className="text-sm text-[#5D4A3A] line-clamp-2">
          {pet.descricao}
        </p>

        {/* Info Row */}
        <div className="flex items-center gap-4 text-xs text-[#7A5B3E]">
          {pet.ponto_referencia && (
            <div className="flex items-center gap-1">
              <MapPin className="w-3 h-3" />
              <span className="truncate max-w-[100px]">{pet.ponto_referencia}</span>
            </div>
          )}
          <div className="flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            <span>{formatDate(pet.created_at)}</span>
          </div>
        </div>

        {/* User Info & Contact */}
        <div className="pt-3 border-t border-[#C4956A] flex items-center gap-2">
          <div className="w-8 h-8 bg-[#6B5344] rounded-full flex items-center justify-center flex-shrink-0">
            <User className="w-4 h-4 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-[#5D4A3A] truncate">{pet.usuario_nome}</p>
          </div>
          <a
            href={`mailto:miaucaomigo@gmail.com?subject=Contato sobre o pet ${pet.nome} (${statusLabels[pet.status]})&body=Olá! Vi o anúncio do pet "${pet.nome}" no MiauCãoMigo e gostaria de mais informações.`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#6B5344] text-white text-xs font-semibold rounded-full hover:bg-[#5D4A3A] transition-colors flex-shrink-0"
            data-testid={`contact-email-${pet.id}`}
          >
            <Mail className="w-3.5 h-3.5" />
            Contato
          </a>
        </div>
      </div>
    </div>
  );
};

export default PetCard;
